function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLigthing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fillRule: "evenodd",
    clipRule: "evenodd",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.542 10.375h4.875L9.833 18.5l1.625-4.875H6.583L14.167 5.5Z",
    style: {
      fill: "#fff",
      fillopacity: 1,
      stroke: "none",
      strokeWidth: 0.54166663
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLigthing);
export default __webpack_public_path__ + "static/media/icon_ligthing.0bd59e49c6ea5880f6f7e3e11157a338.svg";
export { ForwardRef as ReactComponent };